'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);









function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowLeft = function ArrowLeft(props) {
  return _react2.default.createElement(
    'svg',
    { style: {width: (props.size || '24px'), height: (props.size || '24px')}, viewBox: (props.viewBox || '0 0 24 24'), className: props.className },
    _react2.default.createElement('path', { d: 'M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z' })
  );
};

ArrowLeft.displayName = 'ArrowLeft';


exports.default = ArrowLeft;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-mdi/icons/arrow-left.js
 ** module id = 213
 ** module chunks = 0
 **/